/*
 * Project: LegalPlace assistant
 * File: src\components\misc\radio.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { guid, generateId1 } from '../utils/misc';
import { initOutputVariable, initOutputOption, checkRadio1 } from '../../redux/actions/output';
import { endEditionMode } from '../utils/siblings';
// what.
// additional components
import LpHelper from './helper';
import { rsRegisterAction } from '../utils/radio_show';
import { raiseOption } from '../../logic/action_counter';
import { lpGetOptionById, lpGetVariableById } from '../../logic/re_index';
import { editedDocument } from '../../redux/actions/account_settings';
import { isDocumentEdited } from '../../globals';
import lpApp from '../../app/lp_app';
import ConditionsEvo from '../../logic/condition_evo';

const inlineStyle = {
  width: '80%',
};
// we have key, label, parent, id
class SingleRadio extends Component {
  constructor(props) {
    super(props);
    // the elasticity
    this.params = {
      ...props,
    };
    // TODO: ommit this one test
    if ('key' in props) this.key = props.key;
    else this.key = props.lpKey;
    // Creates the this thing.
    this.clickCallback = this.clickCallback.bind(this);
    //
  }

  componentWillMount() {
    const id = this.props.copy === -2 ? this.props.id : `${this.props.id}_${this.props.copy}`;
    const { value } = lpApp.indexes.options.getOption(id);
    if (!this.props.exists) {
      this.props.initOutputSystem(
        this.props.id,
        this.props.lpKey,
        this.props.ovc,
        value,
        this.props.isDuplicate,
        this.props.copy,
      );
    }
  }

  shouldComponentUpdate(nextProps) {
    if (!nextProps.i_update
      || lpApp.action_tracker.last_action === 'EDIT_VARIABLE_VALUE_'
      || lpApp.action_tracker.last_action === 'IC_SET_VARIABLE_'
      || lpApp.action_tracker.last_action === 'IC_SET_OPTION_'
    ) {
      return false;
    }
    return true;
  }

  clickCallback() {
    this.props.changeValue(
      this.props.id,
      this.props.group,
      this.props.isDuplicate,
      this.props.copy,
    );
    endEditionMode(this.lpKey, false);
    rsRegisterAction(this.props.id, this.props.parent, this.props.isDuplicate, this.props.copy);
    let cId = this.props.id;
    if (this.props.isDuplicate) {
      cId = `${cId}_${this.props.copy}`;
    }
    raiseOption(cId);
  }

  render() {
    // If option's condition isn't respected, let's stop right here
    if(this.props.condition === false)
      return null;

    return (<div
      data-type="radio"
      data-id={this.props.id}
      data-is-duplicate={this.props.isDuplicate}
      data-copy={this.props.copy}
      className={`form-group wzog-option${!lpApp.ops.two_steps.isDiscovered(this.props.id, 'option') ? ' highlight-second' : ''}`}
      key={`rad_${guid()}`}
    >
      <input
        type="radio"
        onClick={evt => this.clickCallback(evt)}
        onChange={() => {}}
        key={generateId1(1)}
        name={this.props.isDuplicate ? `${this.props.group}_${this.props.copy}` : this.props.group}
        id={this.props.isDuplicate ? `${this.props.id}_${this.props.copy}` : this.props.id}
                            // value={ this.props.label }
        style={inlineStyle}
        checked={this.props.is_checked}
      />

      <label htmlFor={this.props.isDuplicate ? `${this.props.id}_${this.props.copy}` : this.props.id}>
        { ('just_me' in this.props) && (this.props.just_me) ? (this.props.id ? lpApp.references.getOption(this.props.id).meta.label : 'None') : this.props.label }
        {' '}
        {'helper' in lpApp.references.getOption(this.props.id).meta && lpApp.references.getOption(this.props.id).meta.helper.length > 0 && <LpHelper text={lpApp.references.getOption(this.props.id).meta.helper} />}
      </label>

    </div>);
  }
}

const mapStateToProps = (state, ownProps) => {
  // the thing
  let checked = false;
  let exists = false;
  let existsKey = '';
  const existsParent = '';
  let condition = true;
  if (lpApp.action_tracker.last_action === 'EDIT_VARIABLE_VALUE_') {
    return {
      i_update: false,
      exists: true,
    };
  }
  // get if i'ts checked
  const cId = ownProps.isDuplicate ? `${ownProps.id}_${ownProps.copy}` : ownProps.id;
  if (ownProps.ovc === 'o') {
    const lpOption = lpGetOptionById(cId);
    if (typeof lpOption !== 'undefined') {
      exists = true;
      checked = lpOption.value;
      existsKey = lpOption.key;
    }
  }
  if (ownProps.ovc === 'v') {
    const lpOption = lpGetVariableById(cId);
    if (typeof lpOption !== 'undefined') {
      exists = true;
      checked = lpOption.value;
      existsKey = lpOption.key;
    }
  }

  let option_ref = lpApp.references.getOption(ownProps.id);
  if(typeof(option_ref) === 'object' && option_ref.meta.conditional){
    condition = ConditionsEvo.getCondition(cId)
  }


  return {
    // exists: checkUIExists(state.flat, ownProps.id, ownProps.genre),
    sectionId: state.contract.currentSection,
    checked,
    exists,
    condition,
    existant_key: existsKey,
    existant_parent: existsParent,
  };
};

const mapDispatchToProps = dispatch => ({

  initOutputSystem: (id, parent, genre, value, isDuplicate, copy) => {
    //
    // check duplication
    const cId = !isDuplicate ? id : `${id}_${copy}`;
    const cPid = !isDuplicate ? parent : `${parent}_${copy}`;

    if (genre === 'o') dispatch(initOutputOption(cId, cPid, value));
    else if (genre === 'v') dispatch(initOutputVariable(cId, cPid, value));
  },
  changeValue: (id, parent, isDuplicate, copy) => {
    const cId = !isDuplicate ? id : `${id}_${copy}`;
    const cPid = !isDuplicate ? parent : `${parent}_${copy}`;

    dispatch(checkRadio1(cId, cPid));
    dispatch({ type: 'UPDATE_SECTIONS_C' });
    if (!isDocumentEdited()) dispatch(editedDocument(true));
  },
});

const LpSingleRadio = connect(mapStateToProps, mapDispatchToProps)(SingleRadio);

export default LpSingleRadio;



// WEBPACK FOOTER //
// ./src/components/misc/radio.js